import React, { FC } from 'react';


import styles from './saved-payment-item.less';
import { PaymentMethodType, PaymentMethodInfo } from 'src/invoice/types/types';
import { Radio } from '@material-ui/core';

interface SavedPaymentItemProps {
    paymentMethod: PaymentMethodInfo;
    showDivider: boolean;
    selected: boolean;
    onSelectPaymentMethod: (paymentMethodId: number) => void;
}

export const SavedPaymentItem: FC<SavedPaymentItemProps> = ({
    paymentMethod: {
        paymentMethodId,
        primary,
        icon,
        expires,
        bankName,
        customerName,
        paymentMethodType,
        displayText
    },
    selected,
    showDivider,
    onSelectPaymentMethod
}) => (
    <>
        <label>
            <div className={styles.savedItemContainer}>
                <Radio checked={selected} onChange={() => onSelectPaymentMethod(paymentMethodId)} />
                <img className={styles.savedItemLogo} src={icon || 'assets/images/ach-account.png'} alt={displayText} />
                <div className={styles.savedItemDetails}>
                    <div className={styles.savedItemText}>{displayText}</div>
                    {expires && (<div className={styles.savedItemSubText}>Expires {expires}</div>)}
                    {bankName && paymentMethodType !== PaymentMethodType.CreditCard && (<div className={styles.savedItemSubText}>{bankName}</div>)}
                    {customerName && (<div className={styles.savedItemSubText}>{customerName}</div>)}
                </div>
                {primary && (
                    <div className={styles.savedItemChipHolder}>
                        <div className={styles.savedItemChipContainer}>
                            <div className={styles.savedItemChip}>
                                Primary
                            </div>
                        </div>
                    </div>)}
            </div>
        </label>
        {showDivider && (
            <div className={styles.savedItemDivider} />
        )}
    </>
);